module.exports = __webpack_public_path__ + "static/img/bg_do_not_give_up.3b80ae4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fanclub/notes/bg_do_not_give_up.png
// module id = Ly8J
// module chunks = 1